import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { getTaskPresignedUploadUrl } from '../redux/actions/tasks';
import { validateTaskFile } from '../common/taskUploads';
import { useR2Upload } from './useR2Upload';

/**
 * Sube un adjunto del módulo Tareas (tarea o entrega) a R2 con URL prefirmada.
 */
export const useTaskAttachment = (courseId) => {
    const dispatch = useDispatch();

    const requestPresign = useCallback((file, mimeType) => {
        if (!courseId) {
            return Promise.reject(new Error('No hay curso activo.'));
        }
        return dispatch(getTaskPresignedUploadUrl(courseId, {
            fileName: file.name,
            mimeType,
            size: file.size,
        }));
    }, [courseId, dispatch]);

    return useR2Upload({
        validateFile: validateTaskFile,
        requestPresign,
    });
};
